/*
 * @Author: Lina
 * @Date: 2020-06-29 11:25:59
 * @LastEditors: Lina
 * @LastEditTime: 2020-08-21 14:18:30
 */
const jumptoSearchUrl = (data) => {
  let query = []
  let params = ''
  for (const key in data) {
    if (data[key]) {
      // params += `&${  key  }=${  data[key]}`
      query.push(`${key}=${data[key]}`)
    }
  }
  params = query.join('&')
  return params;
}

export default { jumptoSearchUrl }


